const normalizeKemProgress = (value: string | number): number | undefined => {
  const parsed =
    typeof value === "number" ? value : Number.parseFloat(value.trim());

  if (Number.isNaN(parsed)) {
    return undefined;
  }

  return Math.max(0, Math.min(100, parsed));
};

export default normalizeKemProgress;
